/* eslint-disable brace-style */
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { I18nService } from '@yourcause/common/i18n';
import { YCModalComponent } from '@yourcause/common/modals';

///
/// Component/modal that allows answering or editing of custom responses to persona questions that have answers that allow custom responses.
///

@Component({
    selector: 'yc-add-edit-persona-answer-custom-response-modal',
    templateUrl: './add-edit-persona-answer-custom-response-modal.component.html',
    styleUrls: ['./add-edit-persona-answer-custom-response-modal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})

export class AddEditPersonaAnswerCustomResponseModalComponent extends YCModalComponent<string> implements OnInit {
  //  the question the answer being added/edited belongs to
  @Input() systemQuestion: string;

  //  the answer that is being added/edited
  @Input() systemAnswer: string;

  //  the current custom response for the answer
  @Input() customResponse: string;

  @Input() newUserForUnansweredQuestions: boolean = false;

  //  title for the modal
  title: string;

  //  the form for the custom response for the answer
  personaSystemAnswerCustomResponseForm: UntypedFormGroup;

  //  will hold the primary button text
  primaryButtonText: string;

  //  will hold the cancel button text
  cancelButtonText: string;

  constructor (
    public formBuilder: UntypedFormBuilder,
    private i18nService: I18nService
  ) {
    super();
  }

  ngOnInit () {
    //  make it such that when editing or adding an answer, a response is required
    this.personaSystemAnswerCustomResponseForm = this.formBuilder.group({
      userCustomResponse: [this.customResponse || '', Validators.required]
    });

    this.buildTitleForModal();
  }

  buildTitleForModal () {
    //  Signing up - Title should show 'Set Up Your Profile'
    if (this.newUserForUnansweredQuestions) {
      this.title = this.i18nService.translate(
        'account:SetUpYourProfile',
        {},
        'Set Up Your Profile'
      )
    }
    //  Other areas - Title should show 'Update Your Profile'
    else {
      this.title = this.i18nService.translate(
        'account:UpdateYourProfile',
        {},
        'Update Your Profile'
      );
    }
  }

  //  user opts to not save their new answer or their update to existing answer
  _onCancel () {
    this.closeModal.emit();
  }

  //  user opts to save their new answer or their update to existing answer
  _onSubmit () {
    this.closeModal.emit(this.personaSystemAnswerCustomResponseForm.value.userCustomResponse);
  }
}
